import FlexWithGap from '../FlexWithGap';
import { CheckboxWithLabel } from '../Checkbox';
import React from 'react';

export default function ScoreboardOptions({
                                            includeHiddenTeams,
                                            setIncludeHiddenTeams,
                                            autoRefreshGraph,
                                            setAutoRefreshGraph,
                                            isAdmin = false
                                          }) {
  return (
    <FlexWithGap gap="20px">
      {isAdmin && <CheckboxWithLabel checkboxId="toggle-hidden-teams"
                                     labelText="Include Hidden Teams"
                                     checked={includeHiddenTeams}
                                     setState={setIncludeHiddenTeams} />}
      <CheckboxWithLabel checkboxId="auto-refresh"
                         labelText="Auto refresh score"
                         checked={autoRefreshGraph}
                         setState={setAutoRefreshGraph} />
    </FlexWithGap>
  );
}